import { render, staticRenderFns } from "./RecoverViaCall.vue?vue&type=template&id=12e3383a&"
import script from "./RecoverViaCall.vue?vue&type=script&lang=js&"
export * from "./RecoverViaCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports